<template>
  <div class="container mt-5 mb-5">
    <div class="row">
      <!-- Meniu lateral -->
<!-- Meniu lateral --><div class="col-md-3 mb-3">
<div class="list-group shadow">
  <a href="#" @click.prevent="menuState = 'cont'" class="list-group-item list-group-item-action">
    <i class="fa fa-user me-2"></i> {{ $t("dashboard.accountInfo") }}
  </a>
  <a href="#" @click.prevent="menuState = 'facturi'" class="list-group-item list-group-item-action">
    <i class="fa fa-file me-2"></i> {{ $t("dashboard.myInvoices") }}
  </a>
  <a href="#" @click.prevent="menuState = 'bilete'" class="list-group-item list-group-item-action">
    <i class="fa fa-ticket me-2"></i> {{ $t("dashboard.myTickets") }}
  </a>
  <a href="#" @click.prevent="menuState = 'support'" class="list-group-item list-group-item-action">
    <i class="fa fa-headphones me-2"></i> {{ $t("dashboard.supportTickets") }}
  </a>
  <a href="#" @click.prevent="menuState = 'mesaje'" class="list-group-item list-group-item-action">
    <i class="fa fa-envelope me-2"></i> {{ $t("dashboard.clientMessages") }}
  </a>
  <a href="#" @click.prevent="menuState = 'bonuri'" class="list-group-item list-group-item-action">
    <i class="fa fa-bookmark me-2"></i> {{ $t("dashboard.myReceipts") }} <!-- ✅ Adăugat Bonuri -->
  </a>
</div></div>

      <!-- Conținut dinamic -->
      <div class="col-md-9">
        <div class="card shadow-lg p-4">
          <component :is="currentComponent"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FacturileMele from "@/components/FacturileMele.vue";
import BileteleMele from "@/components/BileteleMele.vue";
import SupportTickets from "@/components/SupportTickets.vue";
import MesajeClient from "@/components/MesajeClient.vue";
import ContulMeu from "@/components/ContulMeu.vue";
import BonurileMele from "@/components/BonurileMele.vue";  // ✅ Adăugăm componenta nouă

export default {
  name: "ClientDashboard",
  data() {
    return {
      menuState: "cont",
      components: {
        facturi: FacturileMele,
        bilete: BileteleMele,
        support: SupportTickets,
        mesaje: MesajeClient,
        cont: ContulMeu,
        bonuri: BonurileMele, // ✅ Adăugăm opțiunea pentru Bonuri
      },
    };
  },
  computed: {
    currentComponent() {
      return this.components[this.menuState] || ContulMeu;
    },
  },
  created() {
    const savedMenuState = localStorage.getItem("menuState");
    if (savedMenuState) {
      this.menuState = savedMenuState;
      localStorage.removeItem("menuState");
    }
  }
};
</script>
